// Only an opaque user ID and a marker are stored: never the session token,
// report contents, reporter email, or created issue details. This protects a
// single browser tab from accidental resubmission, not server-side idempotency.
const markerKey = (userId: string | number) =>
  `hubble:bug-report:pending:${encodeURIComponent(String(userId))}`

export const readBugReportSubmission = (userId: string | number) => {
  try {
    return {
      pending: sessionStorage.getItem(markerKey(userId)) === 'pending',
      durable: true,
    }
  } catch {
    return { pending: false, durable: false }
  }
}

export const markBugReportSubmission = (
  userId: string | number,
  pending: boolean
) => {
  try {
    if (pending) sessionStorage.setItem(markerKey(userId), 'pending')
    else sessionStorage.removeItem(markerKey(userId))
    return true
  } catch {
    return false
  }
}
